export default function SectionsB() {
  return (
    <>
      {/* ===== #faq ===== */}
      <section id="faq" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">常见问题</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">关于女神漫画网免费看的常见疑问解答</p>
          </div>
          <div className="space-y-3">
            {[
              { q: '女神漫画网真的完全免费吗？', a: '是的！女神漫画网所有漫画均为免费全集在线看，无需付费或订阅。我们通过广告合作维持运营，让每一位漫迷都能享受女神漫画免费下拉式阅读的乐趣。' },
              { q: '支持哪些设备阅读？', a: '女神漫画网完美适配电脑、平板和手机浏览器。特别优化的女神漫画下拉式在线阅读模式，让您在手机上也能流畅浏览全部免费全集漫画。' },
              { q: '漫画更新频率如何？', a: '女神漫画网每日更新追更推荐，热门连载保持同步更新节奏。韩漫、日漫、国漫均有专属更新计划，确保您追更不落进度。' },
              { q: '如何找到想看的漫画？', a: '您可以通过首页的热门排行榜、精选推荐、漫画索引等模块快速发现感兴趣的漫画。女神漫画网免费看平台提供多维度分类导航，帮您轻松找到好看的免费漫画大全。' },
            ].map((item, i) => (
              <details key={i} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.q}</h3>
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                    <i className="ri-add-line text-secondary-500"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* ===== #topics ===== */}
      <section id="topics" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门话题</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网读者最关注的热门标签和讨论话题</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { label: '女神漫画免费全集', icon: 'ri-bookmark-line', hot: true },
              { label: '韩漫推荐', icon: 'ri-kakao-talk-line', hot: true },
              { label: '日漫经典', icon: 'ri-sun-line', hot: false },
              { label: '国漫崛起', icon: 'ri-flag-2-line', hot: true },
              { label: '恋爱甜宠漫画', icon: 'ri-heart-line', hot: false },
              { label: '穿越逆袭题材', icon: 'ri-loop-left-line', hot: false },
              { label: '免费下拉式阅读', icon: 'ri-arrow-down-line', hot: true },
              { label: '每日更新追更', icon: 'ri-calendar-check-line', hot: false },
              { label: '校园女神系列', icon: 'ri-building-2-line', hot: false },
            ].map((topic, i) => (
              <span
                key={i}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap ${
                  topic.hot
                    ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                    : 'bg-secondary-100 text-secondary-600 hover:bg-secondary-200'
                }`}
              >
                <i className={`${topic.icon} text-sm`}></i>
                <span className="text-sm font-medium">{topic.label}</span>
                {topic.hot && (
                  <span className="text-[10px] bg-accent-500 text-background-50 px-1.5 py-0.5 rounded-full leading-none">热</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ===== #index ===== */}
      <section id="index" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">漫画索引</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网按题材分类的漫画索引，帮您快速找到感兴趣的免费全集漫画</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {[
              { label: '恋爱校园', count: 328, icon: 'ri-heart-pulse-line' },
              { label: '古风穿越', count: 215, icon: 'ri-ancient-gate-line' },
              { label: '都市甜宠', count: 276, icon: 'ri-building-line' },
              { label: '奇幻冒险', count: 189, icon: 'ri-compass-3-line' },
              { label: '悬疑推理', count: 142, icon: 'ri-search-eye-line' },
              { label: '热血格斗', count: 167, icon: 'ri-sword-line' },
              { label: '治愈日常', count: 203, icon: 'ri-cup-line' },
            ].map((item, i) => (
              <div key={i} className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer border border-background-200/50">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className={`${item.icon} text-xl text-primary-500`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-700 whitespace-nowrap">{item.label}</h3>
                <span className="text-xs text-foreground-400">{item.count} 部</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== #carousel ===== */}
      <section id="carousel" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精选推荐</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网编辑团队精选的免费女神漫画全集推荐</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            <div className="flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20with%20beautiful%20school%20uniform%20female%20character%20under%20cherry%20blossoms%2C%20warm%20coral%20pink%20tones%2C%20Japanese%20anime%20art%20style%2C%20cream%20sky%20background%2C%20soft%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20illustration&width=800&height=600&seq=carousel-01&orientation=landscape" alt="女神漫画网精选 - 樱花树下的约定" title="女神漫画网精选推荐 - 樱花树下的约定" className="w-full h-full object-cover object-top" />
                <div className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-background-50 text-[10px] font-semibold rounded-md whitespace-nowrap">编辑精选</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800">樱花树下的约定</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">校园恋爱漫画巅峰之作，青梅竹马的纯爱故事感动百万读者</p>
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">恋爱</span>
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">校园</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20scene%20with%20powerful%20female%20warrior%20in%20ancient%20Chinese%20palace%2C%20warm%20golden%20amber%20tones%2C%20dramatic%20lighting%2C%20flowing%20robes%2C%20Japanese%20anime%20style%2C%20cream%20background%2C%20clean%20illustration&width=800&height=600&seq=carousel-02&orientation=landscape" alt="女神漫画网精选 - 凤舞九天" title="女神漫画网精选推荐 - 凤舞九天" className="w-full h-full object-cover object-top" />
                <div className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-background-50 text-[10px] font-semibold rounded-md whitespace-nowrap">人气推荐</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800">凤舞九天</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">古风穿越神作，废柴千金逆袭成女帝，画风精美剧情扣人心弦</p>
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">古风</span>
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">逆袭</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Modern%20urban%20manga%20scene%20with%20stylish%20female%20CEO%20character%20in%20office%20setting%2C%20warm%20coral%20and%20amber%20tones%2C%20Japanese%20anime%20art%20style%2C%20chic%20atmosphere%2C%20clean%20cream%20background%2C%20professional%20illustration&width=800&height=600&seq=carousel-03&orientation=landscape" alt="女神漫画网精选 - 总裁女神" title="女神漫画网精选推荐 - 总裁女神" className="w-full h-full object-cover object-top" />
                <div className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-background-50 text-[10px] font-semibold rounded-md whitespace-nowrap">口碑佳作</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800">总裁女神</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">霸道女总裁的甜蜜恋情，都市职场中的浪漫邂逅引爆全网讨论</p>
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">都市</span>
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">甜宠</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Mysterious%20noir%20manga%20scene%20with%20elegant%20female%20detective%20character%20in%20rainy%20city%2C%20warm%20amber%20streetlights%2C%20Japanese%20anime%20style%2C%20suspenseful%20atmosphere%2C%20cream%20highlights%2C%20clean%20illustration%2C%20film%20noir%20mood&width=800&height=600&seq=carousel-04&orientation=landscape" alt="女神漫画网精选 - 午夜女神探" title="女神漫画网精选推荐 - 午夜女神探" className="w-full h-full object-cover object-top" />
                <div className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-background-50 text-[10px] font-semibold rounded-md whitespace-nowrap">新作推荐</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800">午夜女神探</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">悬疑推理漫画新标杆，每话环环相扣令人欲罢不能的精彩作品</p>
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">悬疑</span>
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">推理</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Warm%20healing%20manga%20scene%20with%20gentle%20female%20character%20and%20cat%20in%20cozy%20cafe%2C%20soft%20coral%20and%20cream%20tones%2C%20Japanese%20anime%20style%2C%20peaceful%20slice%20of%20life%20atmosphere%2C%20clean%20illustration%2C%20warm%20lighting%2C%20comforting%20mood&width=800&height=600&seq=carousel-05&orientation=landscape" alt="女神漫画网精选 - 猫咪与女神" title="女神漫画网精选推荐 - 猫咪与女神" className="w-full h-full object-cover object-top" />
                <div className="absolute top-3 left-3 px-2 py-1 bg-accent-500 text-background-50 text-[10px] font-semibold rounded-md whitespace-nowrap">治愈之选</div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800">猫咪与女神</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">温馨治愈日常漫画，女孩与流浪猫的暖心故事，每一页都令人会心一笑</p>
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">治愈</span>
                  <span className="text-[10px] px-2 py-0.5 bg-secondary-100 text-secondary-600 rounded-full whitespace-nowrap">日常</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}